module.exports = __webpack_public_path__ + "img/NOYA_02.0d91b51a.jpg";